export enum PivotKey {
  Class = "Class",
  Dataset = "Dataset",
  Domain = "Domain",
  Scenario = "Scenario",
  DataStructure = "DataStructure",
  VariableSet = "VariableSet",
  Item = "Item",
}